module.exports = __webpack_public_path__ + "img/199.04036e3a.jpg";